export const QUERY_KEYS = {
  TRANSACTION: 'transaction' as const,
  TRANSACTIONS: 'transactions' as const,
  TRANSFER: 'transfer' as const,
  SMART_ACCOUNT: 'smartAccount' as const,
  ORG_SMART_ACCOUNTS: 'orgSmartAccounts' as const,
  ORG_ROOT_ACCOUNT: 'orgRootAccount' as const,
  SMART_ACCOUNT_BALANCES: 'smartAccountBalances' as const,
  ORG_BALANCES: 'orgBalances' as const,
  CONTACT_SEARCH: 'contactSearch' as const,
  FARCASTER_SEARCH: 'farcasterSearch' as const,
  CONTACT_LOOKUP: 'contactLookup' as const,
  ENS_LOOKUP: 'ensLookup' as const,
  ADDRESS_LOOKUP: 'addressLookup' as const,
  FARCASTER_LOOKUP: 'farcasterLookup' as const,
  ORG_COMPLIANCE: 'orgCompliance' as const,
  USER_COMPLIANCE: 'userCompliance' as const,
  PAYER_INVITATIONS: 'payerInvitations' as const,
  PAYEE_LOOKUP_BY_ADDRESS: 'payeeLookupByAddress' as const,
  PAYEE_LOOKUP_BY_ID: 'payeeLookupById' as const,
  PAYEE_1099: 'payee1099' as const,
  AUTH_USER: 'authUser' as const,
  DASHBOARD: 'dashboard' as const,
  POST_ONBOARDING_CHECKLIST: 'postOnboardingChecklist' as const,
  ACTIVE_ORG: 'activeOrg' as const,
  MESSAGE: 'message' as const,
  MESSAGES: 'messages' as const,
  GAS_ESTIMATES: 'gasEstimates' as const,
  UPDATE_GAS_ESTIMATION: 'updateGasEstimation' as const,
  SMART_ACCOUNT_NFT_BALANCES: 'smartAccountNFTBalances' as const,
  LATEST_TRANSFERS: 'latestTransfers' as const,
  MICRODEPOSITS: 'microdeposits' as const,
  ADMIN_TABLE: 'adminTable' as const,
  ADMIN_DETAIL: 'adminDetail' as const,
  ADMIN_NFT_TOKENS: 'adminNFTTokens' as const,
  ADMIN_NFT_TOKEN_SPAM_CHECK_PROMPT: 'adminNFTTokenSpamCheckPrompt' as const,
  ADMIN_ORGS_COMMAND_MENU: 'adminOrgsCommandMenu' as const,
  VAULT_APY: 'vaultApy' as const,
  VAULT_ASSETS: 'vaultAssets' as const,
  SCHEDULES: 'schedules' as const,
  SCHEDULE: 'schedule' as const,
  INVOICES: 'invoices' as const,
  INVOICE: 'invoice' as const,
  AUTOMATIONS: 'automations' as const,
  AUTOMATION: 'automation' as const,
  PUBLIC_INVOICE: 'publicInvoice' as const,
  PLANS: 'plans' as const,
  INVOICE_INBOUND_TRANSFERS: 'invoiceInboundTransfers' as const,
  INVOICE_SCHEDULES: 'invoiceSchedules' as const,
  INVOICE_SCHEDULE: 'invoiceSchedule' as const,
  INVOICE_SCHEDULE_PREVIEW: 'invoiceSchedulePreview' as const,
  ORG_ACCOUNTING_ITEMS: 'orgAccountingItems' as const,
  ORG_ACCOUNTING_LOTS: 'orgAccountingLots' as const,
  ORG_ACCOUNTING_LOT_DISPOSALS: 'orgAccountingLotDisposals' as const,
  ORG_ACCOUNTING_LOT_ASSERTIONS: 'orgAccountingLotAssertions' as const,
  ORG_ACCOUNTING_LOT_RECOMPUTE: 'orgAccountingLotRecompute' as const,
  ORG_ACCOUNTING_REPORTS: 'orgAccountingReports' as const,
  SIMULATE_CALLS: 'simulateCalls' as const,
  TRANSACTION_STATE_CHANGE: 'transactionStateChange' as const,
  HISTORICAL_TOKEN_PRICES: 'historicalTokenPrices' as const,
  SWAP_QUOTE: 'swapQuote' as const,
  REFERRAL_CODE: 'referralCode' as const,
  PASSKEY_SMART_ACCOUNTS: 'passkeySmartAccounts' as const,
  PENDING_PRICING_CALLS: 'pendingPricingCalls' as const,
  TOKEN_PRICE: 'tokenPrice' as const,
  TOKEN_METADATA: 'tokenMetadata' as const,
  TOKEN_METADATA_SEARCH: 'tokenMetadataSearch' as const,
  LOAD_MULTIPLE_TOKEN_METADATA: 'loadMultipleTokenMetadata' as const,
  TOKEN_LOGOS: 'tokenLogos' as const,
  TOKEN_LOGO: 'tokenLogo' as const,
  PRICES_VERSION: 'pricesVersion' as const,
  RELAY_NETWORKS: 'relayNetworks' as const,
  RELAY_NETWORK: 'relayNetwork' as const,
  RELAY_CURRENCY_SEARCH: 'relayCurrencySearch' as const,
  CHAIN_REGISTRY: 'chainRegistry' as const,
  WATCHED_ACCOUNT_BALANCES: 'watchedAccountBalances' as const,
  WALLET_DEPOSIT_BALANCES: 'walletDepositBalances' as const,
  CARDS: 'cards' as const,
  CARD_BALANCES: 'cardBalances' as const,
  CARD_TRANSFERS: 'cardTransfers' as const,
  REQUEST_EXTENSION: 'requestExtension' as const,
  VESTING_ORG_ACCOUNT_BALANCES: 'vestingOrgAccountBalances' as const,
  VESTING_CALLS_TO_CLAIM: 'vestingCallsToClaim' as const,
  VESTING_DETAILS: 'vestingDetails' as const,
  FUNCTION_SIGNATURE: 'functionSignature' as const,
  POSITION_ORG_ACCOUNT_BALANCES: 'positionOrgAccountBalances' as const,
  POSITION_CALLS_TO_CLAIM: 'positionCallsToClaim' as const,
  NFT_COLLECTION_METADATA: 'nftCollectionMetadata' as const,
  HISTORICAL_BALANCES: 'historicalBalances' as const,
  ORG_API_KEYS: 'orgApiKeys' as const,
  ORG_GAS: 'orgGas' as const,
  TOKEN_VISIBILITY: 'tokenVisibility' as const,
  TOKEN_FEATURES: 'tokenFeatures' as const,
  CONTRACT_BYTECODE: 'contractBytecode' as const,
  TOKEN_PRICE_CHART: 'tokenPriceChart' as const,
  INDEXABLE_CHAINS: 'indexableChains' as const,
  CHAIN_HEALTH: 'chainHealth' as const,
  FEATURE_CARDS: 'featureCards' as const,
  ACCOUNT_IMPORT_JOBS: 'accountImportJobs' as const,
  IMPORTED_ACCOUNTS: 'importedAccounts' as const,
  EMAIL_PREFERENCES: 'emailPreferences' as const,
  UNSUBSCRIBE: 'unsubscribe' as const,
}

export const MUTATION_KEYS = {
  TRANSACTION_SIGN: 'sign' as const,
  TRANSACTION_SUBMIT: 'submit' as const,
  TRANSACTION_CONFIRM: 'confirm' as const,
  UPDATE_GAS_ESTIMATION: 'updateGasEstimation' as const,
}
